import { number, string } from "prop-types";

const price = {
  period: string,
  value: number,
  currency: string,
  unit: string,
};

export default price;
